import VirtualTradingModal from 'global/TradingModal/VirtualTradingModal';
import RealTradingModal from 'global/TradingModal/RealTradingModal';
import useTradingAccount from 'hooks/useTradingAccount';
import If from 'global/ErrorHandlers/If';
import tradingDataStore from 'lib/stores/tradingData';
import tradingModalStore from './store';

const TradingModal = () => {
  const { isRealTrading, isVirtualTrading, tradingType } = useTradingAccount();
  const { visible, resetModal, setOrderType } = tradingModalStore();
  const resetModalData = tradingDataStore((s) => s.resetModalData);

  const closeModal = () => {
    resetModal();
    resetModalData();
  };

  const onSwitchTab = (type) => {
    setOrderType(type);
  };

  if (!tradingType) {
    return null;
  }

  return (
    <If condition={visible}>
      <If condition={isVirtualTrading}>
        <VirtualTradingModal
          closeModal={closeModal}
          onSwitchTab={onSwitchTab}
        />
      </If>
      <If condition={isRealTrading}>
        <RealTradingModal closeModal={closeModal} onSwitchTab={onSwitchTab} />
      </If>
    </If>
  );
};

export default TradingModal;
